import { useMemo, useState } from "react";
import { articles } from "../../../mocks/gossip";
import { RowCard } from "../../../components/feature/ArticleCard";
import { Link } from "react-router-dom";

export default function FeedSection() {
  const cats = useMemo(() => ["全部", ...Array.from(new Set(articles.map((a) => a.category)))], []);
  const [tab, setTab] = useState("全部");
  const [showAll, setShowAll] = useState(false);

  const filtered = useMemo(
    () => (tab === "全部" ? articles : articles.filter((a) => a.category === tab)),
    [tab]
  );
  const visible = showAll ? filtered : filtered.slice(0, 5);

  return (
    <section id="feed" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-medium mb-3">
              <i className="ri-typhoon-line" aria-hidden="true"></i> 吃瓜前线
            </span>
            <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">最新爆料 · 实时滚动</h2>
            <p className="text-foreground-500 text-sm mt-1.5">按分类筛选，挑你关心的瓜先啃</p>
          </div>
          <div className="text-xs text-foreground-400 inline-flex items-center gap-1.5 whitespace-nowrap">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-600"></span>
            </span>
            每 15 分钟自动刷新
          </div>
        </div>

        {/* 分类筛选 */}
        <div className="flex flex-wrap gap-2 mb-6">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => { setTab(c); setShowAll(false); }}
              className={`rounded-full px-4 py-2 text-sm font-medium transition cursor-pointer whitespace-nowrap ${
                tab === c
                  ? "bg-primary-600 text-background-50 shadow-sm"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {visible.map((a) => (
            <RowCard key={a.id} article={a} />
          ))}
        </div>

        {filtered.length > 5 && (
          <div className="text-center mt-7">
            <button
              type="button"
              onClick={() => setShowAll((v) => !v)}
              className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-6 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition cursor-pointer whitespace-nowrap"
            >
              {showAll ? "收起" : `查看更多「${tab}」内容`}
              <i className={`ri-arrow-down-s-line text-lg transition-transform ${showAll ? "rotate-180" : ""}`} aria-hidden="true"></i>
            </button>
          </div>
        )}

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 text-sm text-foreground-500">
          <span>没有找到想吃的瓜？</span>
          <Link to="/about#contact" className="text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1 whitespace-nowrap">
            向我们提供线索 <i className="ri-send-plane-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}